import React from "react";
import { BarChart3 } from 'lucide-react';
import { NavItem } from "../NavItem";

export function AnalysisLink({ isCollapsed }) {
    return (
        <NavItem
            redirectUrl="/analysis"
            Icon={BarChart3}
            label="Analysis"
            isCollapsed={isCollapsed}
        />
    );
}